<template src="./Edit.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.$store.dispatch("lookups/GetItemByProcedure", "خدمات تحاليل");
    this.$store.dispatch("lookups/getPaymentAccounts");
    this.$store.dispatch("invoicesAnalysis/getForEdit", this.itemId).then((res) => {
      this.vm = res
      this.vm.patientId = res.id;
      this.vm.fileNo = res.fileNo;
      this.vm.fullName = res.fullName;
      this.vm.appointmentDate = res.appointmentDate;
      this.vm.paymentTypes = res.paymentTypes.split(",").map(Number);
      this.vm.services = res.services;
    });
 
  },
  computed: {
    paymentTypes() {
      return this.$store.state.lookups.paymentAccounts;
    },
    itemPriceList() {
      return this.$store.state.lookups.itemPriceList || [];
    },

  },
  data() {
    return {

      vm: {
        patientId: null,
        appointmentDate: null,
        services: [],
      },
      service: {
        serviceName: null,
        price: null,
      },
      servicePrice: null,
      analysas: {
        analysisGroupId: null,
        analysisId: null,
        price: null,
      },
      indexItem: null,
      editFlag: false,
      headersService: [
        { text: 'اسم التحليل', value: 'serviceName' },
        { text: 'السعر ', value: 'price' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

    };
  },
  methods: {
    getPrice() {
      this.service.price = null;
      let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
      this.service.price = service.price;

    },
    confirm() {
      if (this.vm.services.length == 0) {
        showAlert(`يجب ادخال عنصر واحد على الاقل`);
        return false;
      }
      this.$store
        .dispatch("invoicesAnalysis/edit", { id: this.itemId, payload: this.vm })
        .then(() => {
          this.back();
        })
        .catch(() => { });
    }, getAnalysis() {
      this.$store.dispatch("lookups/getAnalysis", this.analysas.analysisGroupId);

    },

    AddItem() {
      if (this.service.serviceName == null) {
        showAlert(`يجب اختيار التحليل `);
        return false;
      }
      if (this.service.price == null) {
        showAlert(`يجب ادخال السعر `);
        return false;
      }
      var Index = this.vm.services.findIndex(x => x.serviceName == this.service.serviceName);
      if (Index != -1) {
        showAlert(`لا يمكن اضافة نفس التحليل اكثر من مرة   `);
        return false;
      }
      let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
      this.vm.services.push({
        serviceName: this.service.serviceName,
        serviceCode: service.itemCode,
        price: this.service.price,
      });
      this.service.serviceName = null;
      this.service.price = null;
      //this.$refs.info.reset();
    },

    removeItem(index) {
      this.vm.services.splice(index, 1);
    },

    //----------------------------------------------------//


    back() {
      this.$emit("back");
    },
  },
};
</script>